// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditPartnerForm-containerWith-NucmQ {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.EditPartnerForm-container-IAR8G {
    max-width: 100%;
}

/* Text - Start */

.EditPartnerForm-subText-ZwpUs {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.EditPartnerForm-navigationLink-cpyGQ a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.EditPartnerForm-navigationLink-cpyGQ a:hover,
.EditPartnerForm-navigationLink-cpyGQ a:focus,
.EditPartnerForm-navigationLink-cpyGQ a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.EditPartnerForm-noPadding-OxtDV {
    padding: 0;
}

.EditPartnerForm-heading-TP9KU {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.EditPartnerForm-widthInner-n3gNm {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.EditPartnerForm-noMargin-QeXbp {
    margin: 0;
}

.EditPartnerForm-formControlInputTable-XCCu2 {
    border: none;
    width: 100px;
    height: auto;
}

.EditPartnerForm-backBtn-loCMF {
    margin-left: 15px;
    display: inline-block;
}

.EditPartnerForm-backBtn-loCMF:active,
.EditPartnerForm-backBtn-loCMF:hover,
.EditPartnerForm-backBtn-loCMF:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.EditPartnerForm-textAlignRight-crDco {
    text-align: right;
}

.EditPartnerForm-displayInlineBlock-SHqRS {
    display: inline-block;
}

.EditPartnerForm-displayBlock-nzpBy {
    display: block;
}

.EditPartnerForm-countryCode-gYu2P {
    width: 15%;
    vertical-align: top;
}

.EditPartnerForm-vtrMiddle-KGrKk {
    vertical-align: middle;
}

/* commonCss */

.EditPartnerForm-editIcon-bb9dF {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.EditPartnerForm-iconBtn-DFVCG,
.EditPartnerForm-iconBtn-DFVCG:hover,
.EditPartnerForm-iconBtn-DFVCG:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.EditPartnerForm-profileImg-IkOwz {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.EditPartnerForm-profileImgSection-J527B {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.EditPartnerForm-profileImgWidth-pIb9Y {
    margin: 0;
    max-width: 100% !important;
}

.EditPartnerForm-searchInput-kHdw4 {
    width: 100%;
    max-width: 320px;
}

.EditPartnerForm-backgroundImg-q9YRa {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.EditPartnerForm-exportDisplay-EEoHl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.EditPartnerForm-exportTextSection-nYTVd {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.EditPartnerForm-exportText-TDcps {
    display: inline-block;
    padding-right: 5px;
}

.EditPartnerForm-exportTextContainer-dViYy {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.EditPartnerForm-vtrTextBottom-Y1V5g {
    vertical-align: text-bottom;
}

.EditPartnerForm-exportImg-HyZzi {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.EditPartnerForm-noLink-LDnQW,
.EditPartnerForm-noLink-LDnQW:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.EditPartnerForm-singleCard-wJ4F8 {
    width: 500px;
    margin: 0 auto;
}

.EditPartnerForm-defaultIcon-CYYr2 {
    background-size: 50px;
}

.EditPartnerForm-assignProviderSearchInput-BvIDE {
    width: 100%;
    max-width: 324px;
}

.EditPartnerForm-searchGroupContainer-BUSJC {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .EditPartnerForm-searchGroupContainer-BUSJC {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .EditPartnerForm-widthInner-n3gNm {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .EditPartnerForm-aboutGrid-Je0q2 img {
    position: relative;
    top: -25px !important;
  }

  .EditPartnerForm-responsiveView-eQAl0 {
    width: 100% !important;
    max-width: 175px !important;
  }

  .EditPartnerForm-positionFive-sPaNH {
    top: 28% !important;
  }

  .EditPartnerForm-positionTwo-ti1_8 {
    top: 28% !important;
  }

  .EditPartnerForm-responsiveContentOne-DeYdO {
    top: -50px !important;
  }

  .EditPartnerForm-positionFour-JeGBs {
    top: -50px !important;
  }

  .EditPartnerForm-totalCss-UMdrp {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .EditPartnerForm-navbar-expand-lg-VK_d9 .EditPartnerForm-navbar-toggler-S72Y7 {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .EditPartnerForm-profileImgSection-J527B {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .EditPartnerForm-navigationLink-cpyGQ a {
    color: var(--primary-foreground) !important;
  }

  .EditPartnerForm-widthInner-n3gNm {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .EditPartnerForm-responsiveContentOne-DeYdO {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .EditPartnerForm-positionTwo-ti1_8 {
    top: 24% !important;
    left: -5% !important;
  }

  .EditPartnerForm-positionThree-oRXBP {
    top: 70% !important;
    left: -5% !important;
  }

  .EditPartnerForm-positionFour-JeGBs {
    top: -42px !important;
    right: -5% !important;
  }

  .EditPartnerForm-positionFive-sPaNH {
    top: 20% !important;
    right: -5% !important;
  }

  .EditPartnerForm-positionSix-ID7cZ {
    top: 70% !important;
    right: -5% !important;
  }

  .EditPartnerForm-responsiveView-eQAl0 {
    width: 100% !important;
    max-width: 115px !important;
  }

  .EditPartnerForm-aboutGrid-Je0q2 img {
    top: -1px !important;
  }

  .EditPartnerForm-contentOne-Uhj18 h1 {
    font-size: 16px !important;
  }

  .EditPartnerForm-contentOne-Uhj18 p {
    font-size: 12px !important;
  }


  .EditPartnerForm-totalCss-UMdrp {
    width: 100% !important;
  }

  .EditPartnerForm-padding-hWVuR {
    padding: 0px 0 0 60px !important;
  }

  .EditPartnerForm-singleCard-wJ4F8 {
    width: 100% !important;
  }

  .EditPartnerForm-navigationLink-cpyGQ a:hover,
  .EditPartnerForm-navigationLink-cpyGQ a:focus,
  .EditPartnerForm-navigationLink-cpyGQ a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .EditPartnerForm-navbar-collapse-pwrjO.EditPartnerForm-show-TVE57 {
    right: 0% !important;
    top: 0 !important;
  }

  .EditPartnerForm-navbar-collapse-pwrjO {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .EditPartnerForm-content-aWkBU {
    float: none;
  }

  .EditPartnerForm-mr-auto-NxuTX.EditPartnerForm-navbar-nav-u2Fit {
    padding-bottom: 80px !important;
  }

  .EditPartnerForm-navigationLink-cpyGQ a {
    color: var(--primary-foreground) !important;
  }

  .EditPartnerForm-footer-FhyLV {
    padding: 35px 0 0 15px;
  }

  .EditPartnerForm-widthInner-n3gNm {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .EditPartnerForm-responsiveNoPadding-qtyL5 {
    padding: 0px !important;
  }

  .EditPartnerForm-contentOne-Uhj18 {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .EditPartnerForm-aboutContainer-D6oqi {
    padding: 30px 0 30px !important;
  }

  .EditPartnerForm-noPosition-BAQWL {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .EditPartnerForm-mobimleImg-LaQ_Z {
    display: none !important;
  }

  .EditPartnerForm-totalCss-UMdrp {
    width: 100% !important;
  }

  .EditPartnerForm-imgWidth-uXa6j {
    padding: 18px !important;
  }

  .EditPartnerForm-searchInput-kHdw4,
  .EditPartnerForm-assignProviderSearchInput-BvIDE {
    max-width: 100% !important;
  }

  .EditPartnerForm-exportText-TDcps {
    display: inline-block;
  }

  .EditPartnerForm-gridSystem-rMA10 {
    grid-template-columns: auto !important;
  }

  .EditPartnerForm-padding-hWVuR {
    padding: 52px 0 0 0 !important;
  }

  .EditPartnerForm-heading-TP9KU {
    padding: 30px 0 24px !important;
  }

  .EditPartnerForm-singleCard-wJ4F8 {
    width: 100% !important;
  }

  .EditPartnerForm-displayGrid-G6jjg {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .EditPartnerForm-boxInner-OCZ8b {
    padding: 35px 0 !important;
  }

  .EditPartnerForm-navigationLink-cpyGQ a:hover,
  .EditPartnerForm-navigationLink-cpyGQ a:focus,
  .EditPartnerForm-navigationLink-cpyGQ a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .EditPartnerForm-whiteDropdown-xDgWb select {
    width: 120px !important;
  }
}

.EditPartnerForm-badgeWrapperFlex-GPGUT {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 6px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.EditPartnerForm-userStatusBadge-ZIiW5 {
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
}

.EditPartnerForm-positionPhoneField-YcW5m {
  position: relative;
  top: 38px;
}

.EditPartnerForm-bannerImageBg-uhKZw {
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.EditPartnerForm-bannerDelete-_z1Gz {
  position: absolute;
  top: -7px;
  right: -7px;
}

.EditPartnerForm-positionRelative-qqhHd {
  position: relative;
  margin: 12px 15px 15px 0;
}

.EditPartnerForm-countryGrid-nn3FJ {
  display: grid;
  grid-template-columns: 75px auto;
}

.EditPartnerForm-editServiceProviderListTitle-qIwdB {
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  color: var(--primary-foreground);
  margin-bottom: 18px;
  text-align: start;
}

.EditPartnerForm-editServiceProviderListCardContainer-O74h2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  gap: 12px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  grid-gap: 12px;
  margin-bottom: 18px;
}

.EditPartnerForm-editServiceProviderListCardItem-ZyLJJ,
.EditPartnerForm-editServiceProviderListCardItem-ZyLJJ:hover,
.EditPartnerForm-editServiceProviderListCardItem-ZyLJJ:focus {
  border: 1px solid var(--primary-border);
  background: var(--background-secondary);
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: var(--primary-foreground);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 6px;
  text-align: start;
  text-decoration: none;
  outline-color: transparent;
}

.EditPartnerForm-editServiceProviderListCardImgBox-PEwqG {
  position: relative;
  width: 15px;
  height: 15px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.EditPartnerForm-editServiceProviderListCardImg-z5Z3B {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

.EditPartnerForm-editServiceProviderBtnGrp-RDTI4 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 18px;
  grid-gap: 18px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--primary-border);
}

.EditPartnerForm-editServiceProviderListLinkContainer-aQRq0 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}

.EditPartnerForm-editServiceProviderListLink-smY2Z,
.EditPartnerForm-editServiceProviderListLink-smY2Z:focus,
.EditPartnerForm-editServiceProviderListLink-smY2Z:hover {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  gap: 6px;
  font-size: 14px;
  grid-gap: 6px;
  font-weight: 400;
  line-height: 24px;
  color: var(--primary-link-foreground);
  text-decoration: unset;
  outline-color: transparent;
  -webkit-box-shadow: none;
          box-shadow: none;
}

@media (max-width:1199px) and (min-width:1024px) {
  .EditPartnerForm-positionPhoneField-YcW5m {
    top: 33px;
  }
}

@media (max-width:1023px) and (min-width:768px) {
  .EditPartnerForm-positionPhoneField-YcW5m {
    top: 8px;
  }
}

@media (max-width: 767px) {
  .EditPartnerForm-positionPhoneField-YcW5m {
    top: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/SiteAdmin/EditPartnerForm/EditPartnerForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,mBAAe;MAAf,eAAe;EACf,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,uCAAuC;EACvC,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;;EAGE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAGA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n.badgeWrapperFlex {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.userStatusBadge {\n  font-size: 14px;\n  font-weight: normal;\n  vertical-align: middle;\n}\n\n.positionPhoneField {\n  position: relative;\n  top: 38px;\n}\n\n.bannerImageBg {\n  width: 120px;\n  height: 120px;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: cover;\n}\n\n.bannerDelete {\n  position: absolute;\n  top: -7px;\n  right: -7px;\n}\n\n.positionRelative {\n  position: relative;\n  margin: 12px 15px 15px 0;\n}\n\n.countryGrid {\n  display: grid;\n  grid-template-columns: 75px auto;\n}\n\n.editServiceProviderListTitle {\n  font-size: 18px;\n  line-height: 28px;\n  font-weight: 600;\n  color: var(--primary-foreground);\n  margin-bottom: 18px;\n  text-align: start;\n}\n\n.editServiceProviderListCardContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  flex-wrap: wrap;\n  grid-gap: 12px;\n  margin-bottom: 18px;\n}\n\n.editServiceProviderListCardItem,\n.editServiceProviderListCardItem:hover,\n.editServiceProviderListCardItem:focus {\n  border: 1px solid var(--primary-border);\n  background: var(--background-secondary);\n  padding: 4px 12px;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 24px;\n  color: var(--primary-foreground);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  text-align: start;\n  text-decoration: none;\n  outline-color: transparent;\n}\n\n.editServiceProviderListCardImgBox {\n  position: relative;\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n}\n\n.editServiceProviderListCardImg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.editServiceProviderBtnGrp {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 18px;\n  grid-gap: 18px;\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid var(--primary-border);\n}\n\n.editServiceProviderListLinkContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.editServiceProviderListLink,\n.editServiceProviderListLink:focus,\n.editServiceProviderListLink:hover {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  font-size: 14px;\n  grid-gap: 6px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--primary-link-foreground);\n  text-decoration: unset;\n  outline-color: transparent;\n  box-shadow: none;\n}\n\n@media (max-width:1199px) and (min-width:1024px) {\n  .positionPhoneField {\n    top: 33px;\n  }\n}\n\n\n@media (max-width:1023px) and (min-width:768px) {\n  .positionPhoneField {\n    top: 8px;\n  }\n}\n\n@media (max-width: 767px) {\n  .positionPhoneField {\n    top: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `EditPartnerForm-containerWith-NucmQ`,
	"container": `EditPartnerForm-container-IAR8G`,
	"subText": `EditPartnerForm-subText-ZwpUs`,
	"navigationLink": `EditPartnerForm-navigationLink-cpyGQ`,
	"noPadding": `EditPartnerForm-noPadding-OxtDV`,
	"heading": `EditPartnerForm-heading-TP9KU`,
	"widthInner": `EditPartnerForm-widthInner-n3gNm`,
	"noMargin": `EditPartnerForm-noMargin-QeXbp`,
	"formControlInputTable": `EditPartnerForm-formControlInputTable-XCCu2`,
	"backBtn": `EditPartnerForm-backBtn-loCMF`,
	"textAlignRight": `EditPartnerForm-textAlignRight-crDco`,
	"displayInlineBlock": `EditPartnerForm-displayInlineBlock-SHqRS`,
	"displayBlock": `EditPartnerForm-displayBlock-nzpBy`,
	"countryCode": `EditPartnerForm-countryCode-gYu2P`,
	"vtrMiddle": `EditPartnerForm-vtrMiddle-KGrKk`,
	"editIcon": `EditPartnerForm-editIcon-bb9dF`,
	"iconBtn": `EditPartnerForm-iconBtn-DFVCG`,
	"profileImg": `EditPartnerForm-profileImg-IkOwz`,
	"profileImgSection": `EditPartnerForm-profileImgSection-J527B`,
	"profileImgWidth": `EditPartnerForm-profileImgWidth-pIb9Y`,
	"searchInput": `EditPartnerForm-searchInput-kHdw4`,
	"backgroundImg": `EditPartnerForm-backgroundImg-q9YRa`,
	"exportDisplay": `EditPartnerForm-exportDisplay-EEoHl`,
	"exportTextSection": `EditPartnerForm-exportTextSection-nYTVd`,
	"exportText": `EditPartnerForm-exportText-TDcps`,
	"exportTextContainer": `EditPartnerForm-exportTextContainer-dViYy`,
	"vtrTextBottom": `EditPartnerForm-vtrTextBottom-Y1V5g`,
	"exportImg": `EditPartnerForm-exportImg-HyZzi`,
	"noLink": `EditPartnerForm-noLink-LDnQW`,
	"singleCard": `EditPartnerForm-singleCard-wJ4F8`,
	"defaultIcon": `EditPartnerForm-defaultIcon-CYYr2`,
	"assignProviderSearchInput": `EditPartnerForm-assignProviderSearchInput-BvIDE`,
	"searchGroupContainer": `EditPartnerForm-searchGroupContainer-BUSJC`,
	"aboutGrid": `EditPartnerForm-aboutGrid-Je0q2`,
	"responsiveView": `EditPartnerForm-responsiveView-eQAl0`,
	"positionFive": `EditPartnerForm-positionFive-sPaNH`,
	"positionTwo": `EditPartnerForm-positionTwo-ti1_8`,
	"responsiveContentOne": `EditPartnerForm-responsiveContentOne-DeYdO`,
	"positionFour": `EditPartnerForm-positionFour-JeGBs`,
	"totalCss": `EditPartnerForm-totalCss-UMdrp`,
	"navbar-expand-lg": `EditPartnerForm-navbar-expand-lg-VK_d9`,
	"navbar-toggler": `EditPartnerForm-navbar-toggler-S72Y7`,
	"positionThree": `EditPartnerForm-positionThree-oRXBP`,
	"positionSix": `EditPartnerForm-positionSix-ID7cZ`,
	"contentOne": `EditPartnerForm-contentOne-Uhj18`,
	"padding": `EditPartnerForm-padding-hWVuR`,
	"navbar-collapse": `EditPartnerForm-navbar-collapse-pwrjO`,
	"show": `EditPartnerForm-show-TVE57`,
	"content": `EditPartnerForm-content-aWkBU`,
	"mr-auto": `EditPartnerForm-mr-auto-NxuTX`,
	"navbar-nav": `EditPartnerForm-navbar-nav-u2Fit`,
	"footer": `EditPartnerForm-footer-FhyLV`,
	"responsiveNoPadding": `EditPartnerForm-responsiveNoPadding-qtyL5`,
	"aboutContainer": `EditPartnerForm-aboutContainer-D6oqi`,
	"noPosition": `EditPartnerForm-noPosition-BAQWL`,
	"mobimleImg": `EditPartnerForm-mobimleImg-LaQ_Z`,
	"imgWidth": `EditPartnerForm-imgWidth-uXa6j`,
	"gridSystem": `EditPartnerForm-gridSystem-rMA10`,
	"displayGrid": `EditPartnerForm-displayGrid-G6jjg`,
	"boxInner": `EditPartnerForm-boxInner-OCZ8b`,
	"whiteDropdown": `EditPartnerForm-whiteDropdown-xDgWb`,
	"badgeWrapperFlex": `EditPartnerForm-badgeWrapperFlex-GPGUT`,
	"userStatusBadge": `EditPartnerForm-userStatusBadge-ZIiW5`,
	"positionPhoneField": `EditPartnerForm-positionPhoneField-YcW5m`,
	"bannerImageBg": `EditPartnerForm-bannerImageBg-uhKZw`,
	"bannerDelete": `EditPartnerForm-bannerDelete-_z1Gz`,
	"positionRelative": `EditPartnerForm-positionRelative-qqhHd`,
	"countryGrid": `EditPartnerForm-countryGrid-nn3FJ`,
	"editServiceProviderListTitle": `EditPartnerForm-editServiceProviderListTitle-qIwdB`,
	"editServiceProviderListCardContainer": `EditPartnerForm-editServiceProviderListCardContainer-O74h2`,
	"editServiceProviderListCardItem": `EditPartnerForm-editServiceProviderListCardItem-ZyLJJ`,
	"editServiceProviderListCardImgBox": `EditPartnerForm-editServiceProviderListCardImgBox-PEwqG`,
	"editServiceProviderListCardImg": `EditPartnerForm-editServiceProviderListCardImg-z5Z3B`,
	"editServiceProviderBtnGrp": `EditPartnerForm-editServiceProviderBtnGrp-RDTI4`,
	"editServiceProviderListLinkContainer": `EditPartnerForm-editServiceProviderListLinkContainer-aQRq0`,
	"editServiceProviderListLink": `EditPartnerForm-editServiceProviderListLink-smY2Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
